import { render, staticRenderFns } from "./result-feature.vue?vue&type=template&id=3dfe74c7&scoped=true&"
import script from "./result-feature.vue?vue&type=script&lang=js&"
export * from "./result-feature.vue?vue&type=script&lang=js&"
import style0 from "./result-feature.vue?vue&type=style&index=0&id=3dfe74c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe74c7",
  null
  
)

export default component.exports